import { CommonDoc } from '@sprinklr/stories/common/CommonDoc';

export interface VersionCapable extends CommonDoc {
    versionId?: string;
}

export const VersionCapableFields = `
versionId
`;
